import React, { useState, useEffect } from "react";
import { Form, Button, Container, Row, Col } from "react-bootstrap";
import { useAuth } from "../../_services/authService";
import { useNavigate, Link } from "react-router-dom";
import { config } from "../../App";
import axios from "axios";
import "./Login.scss";
import RegisterEmp from "./Register";

import {
  loadCaptchaEnginge,
  LoadCanvasTemplate,
  validateCaptcha,
} from "react-simple-captcha";

const Loader = () => (
  <div className="loader-container">
    <img src="./images/loader.gif" alt="loading" />
  </div>
);

const Login2 = () => {
  const [employeeId, setEmployeeId] = useState("");
  const [password, setPassword] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [generalMsg, setGeneralMsg] = useState("");
  const [empError, setEmpError] = useState("");
  const [passError, setPassError] = useState("");
  const [captchaError, setCaptchaError] = useState("");
  const [loading, setLoading] = useState(false);
  const [captchaInput, setCaptchaInput] = useState("");
  const [captchaCode, setCaptchaCode] = useState("");
  const { loginAuth } = useAuth();
  const navigate = useNavigate();

  const [loggedIn, setLoggedIn] = useState(false);
  const [userData, setUserData] = useState({});

  const [isSignin, setIsSignin] = useState(false);

  useEffect(() => {
    document.body.classList.add("authpage");
    //generateCaptcha();
    loadCaptchaEnginge(6);
    return () => {
      document.body.classList.remove("authpage");
    };
  }, []);

  const generateCaptcha = () => {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789@#$!%&*";
    let code = "";
    for (let i = 0; i < 6; i++) {
      code += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    setCaptchaCode(code);
    setCaptchaInput("");

  };

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  const persistUserAuthData = (
    FirstName,
    LastName,
    EmployeeID,
    State,
    Region,
    doj
  ) => {
    sessionStorage.setItem("username", `${FirstName} ${LastName}`);
    sessionStorage.setItem("EmployeeID", EmployeeID);
    sessionStorage.setItem("State", State);
    sessionStorage.setItem("Region", Region);
    sessionStorage.setItem("doj", doj);
  };

  // const employeeIdRegex = /^(EMP|ECN|SG)?[0-9]{4,10}$/i;
  const employeeIdRegex = /^(?:(?:EMP|ECN|SG)?\d{4,10}|[a-zA-Z0-9._%+-]{1,}[@][a-zA-Z0-9.-]{2,}\.[a-zA-Z]{2,})$/i;

  const validateForm = () => {
    let valid = true;

    setEmpError("");
    setPassError("");
    setCaptchaError("");
    setGeneralMsg("");

    if (!employeeId.trim()) {
      setEmpError("Employee ID is required");
      valid = false;
    } 
    // else if (!employeeIdRegex.test(employeeId.trim())) {
    //   setEmpError("Invalid Employee ID");
    //   valid = false;
    // }

    if (!password.trim()) {
      setPassError("Password is required");
      valid = false;
    } else if (password.length < 6) {
      setPassError("Password must be at least 6 characters long");
      valid = false;
    }

    if (!captchaInput.trim()) {
      setCaptchaError("Captcha is required");
      valid = false;
    }

    return valid;
  };

  const getToken = async (loginData) => {
    try {
      const response = await axios.post(
        `${config.endpoint}/auth/login`,
        loginData
      );
      //console.log("response", response.data.Token)
      if (response.data.Status === true) {
        sessionStorage.setItem("token", response.data.Token);
        sessionStorage.setItem("expiryTime", response.data.ExpiryTime);
        // sessionStorage.setItem("expiryTime", "2026-03-19T21:36:10.7125869");

      } else {
        setGeneralMsg(response.data.Message);
      }
    } catch (error) {
      setGeneralMsg(error.response.data.Message);
      //setGeneralMsg("Incorrect Employee ID or Password");
      console.error(error);
      throw error;
    }
  };

  const login = async (formData) => {
    try {
      setLoading(true);
      await new Promise((resolve) => setTimeout(resolve, 1500));

      const response = await axios.post(
        `${config.endpoint}/auth/validate`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );

      console.log("response", response.data.Employee.data)

      if (response.data.Status === true && response.data.Employee.data) {
        loginAuth(sessionStorage.getItem("token"));
        navigate(`/dashboard`);

        persistUserAuthData(
          response.data.Employee.data.FirstName,
          response.data.Employee.data.LastName,
          response.data.Employee.data.EmployeeID,
          response.data.Employee.data.State,
          response.data.Employee.data.Region,
          response.data.Employee.data.DateOfJoining,
        );

        sessionStorage.setItem("userId", response.data.Employee.data.EmployeeID);
        setUserData(response.data.Employee.data);
        setLoggedIn(true);
      } else {
        setGeneralMsg("Incorrect Employee ID or Password");
      }
    } catch (error) {
      console.error("Login error:", error);
      setGeneralMsg("Login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!validateForm()) {
      return;
    }

    //if (captchaInput.trim() !== captchaCode) {
    //setCaptchaError("Incorrect CAPTCHA. Please try again.");
    //generateCaptcha();
    //return;
    //}

    if (!validateCaptcha(captchaInput)) {
      setCaptchaError("Invalid CAPTCHA. Please try again.");
      setCaptchaInput("");
      loadCaptchaEnginge(6);
      return;
    }

    setCaptchaError("");

    const formData = {
      username: employeeId.trim(),
      password,
      appName: "ess",
    };

    try {
      await getToken(formData);
      await login({ username: employeeId.trim(), appName: "ess", });
    } catch (err) {
      //generateCaptcha();
      loadCaptchaEnginge(6);
    }
  };

  // const [activeTab, setActiveTab] = useState("login");

  return (
    <>
      <section className="login-wrapper loginSecondDesign d-flex align-items-center">
        {loading && <Loader />}
        {loading && <div className="backdrop" />}

        <Container>
          <div className="login-card shadow-lg">

            <Row className="">
              <Col md={12}>

                <div className={`card ${isSignin ? "signin-mode" : ""}`}>


                  <div className="overlay-panel">
                    <div class="diamond d1"></div>
                    <div class="diamond d2"></div>
                    <div class="diamond d3"></div>
                    <div class="circle c1"></div>
                    <div class="circle c2"></div>
                    <div class="tri t1"></div>
                    <div className="DesignOne"></div>
                    <div className="DesignTwo"></div>
                    {/* <div className="logo">Diprella</div> */}
                    {/* <div className="logo">
                      <img src="./images/logo.svg" alt="spicejet" className="img-fluid" />
                    </div> */}

                    {!isSignin ? (
                      <div className="overlay-content active">
                        <h2>Hello, Employee!</h2>
                        <p class="overlay-sub">Register to access ESS services including SOD, ELT, payslips, Form 16, and more.</p>
                        <button
                          type="button"
                          onClick={() => setIsSignin(true)}
                        >
                          Register
                        </button>
                      </div>
                    ) : (
                      <div className="overlay-content ps-4 active">
                        <h2>Welcome Back!</h2>
                        <p class="overlay-sub">Access your Employee Self Service portal to manage SOD, ELT, payslips, Form 16, and other employee services.</p>
                        <button
                          type="button"
                          onClick={() => setIsSignin(false)}
                        >
                          Login
                        </button>
                      </div>
                    )}
                  </div>

                  <div className="forms-container">
                    <div className="form-panel signup-form">
                      <div>
                        <div className="logo">
                          <img src="./images/logo.svg" alt="spicejet" className="img-fluid" />
                        </div>
                        <h1 class="mb-lg-3 mt-lg-4 mb-md-3 mt-md-3 pt-3 font-xxxl">
                          ESS<span class="primary-text bold"> Login</span>
                        </h1>

                        {generalMsg && (
                          <p className="font-sm regular mb-3 text-danger">{generalMsg}</p>
                        )}

                        <Form onSubmit={handleSubmit} className="mt-4">
                          <Form.Group className="my-3 pb-4 mb-0 position-relative">
                            <Form.Label className="font-xl">Employee ID<sup class="primary-text font-md">*</sup></Form.Label>
                            <Form.Control
                              type="text"
                              className="form-control p-3 font-md dark-grey-text mb-1"
                              placeholder="Enter Employee ID"
                              value={employeeId}
                              onChange={(e) => {
                                setEmployeeId(e.target.value);
                                if (empError) setEmpError("");
                              }}
                            />
                            {empError && (
                              <div className="font-sm regular mb-3 text-danger position-absolute">{empError}</div>
                            )}
                          </Form.Group>

                          <Form.Group className="my-3 pb-5 mb-0 position-relative">
                            <Form.Label className="font-xl">Password<sup class="primary-text font-md">*</sup></Form.Label>
                            <div className="position-relative">
                              <Form.Control
                                type={passwordVisible ? "text" : "password"}
                                className="form-control p-3 font-md dark-grey-text mb-1"
                                placeholder="Enter Password"
                                value={password}
                                onChange={(e) => {
                                  setPassword(e.target.value);
                                  if (passError) setPassError("");
                                }}
                              />
                              <span
                                className="password-toggle-icon position-absolute end-0 me-4 top-0 mt-4 pt-1"
                                onClick={togglePasswordVisibility}
                              >
                                {passwordVisible ? (
                                  <img className="icon-24" src="./images/eye-fill.svg" alt="show" />
                                ) : (
                                  <img className="icon-24" src="./images/eye-slash.svg" alt="hide" />
                                )}
                              </span>
                            </div>

                            {passError && (
                              <div className="font-sm regular mb-3 text-danger position-absolute">{passError}</div>
                            )}
                          </Form.Group>

                          {/* CAPTCHA */}
                          <div className="form-group mt-0 mb-5">
                            {/* <label className="form-label font-xl">
                        CAPTCHA <sup className="primary-text font-md">*</sup>
                      </label> */}

                            <div className="captcha-container d-flex align-items-center mb-4 flex-wrap">
                              <div className="captcha-display font-weight-bold font-lg">
                                <LoadCanvasTemplate />
                              </div>
                              <button
                                type="button"
                                className="btn refresh-btn"
                                onClick={() => loadCaptchaEnginge(6)}
                                disabled={loading}
                              >
                                ↻
                              </button>

                              <input
                                type="text"
                                className={`form-control captcha-input p-3 font-md mb-1 ${captchaError ? "is-invalid" : ""}`}
                                placeholder="Enter CAPTCHA"
                                value={captchaInput}
                                onChange={(e) => {
                                  setCaptchaInput(e.target.value);
                                  if (captchaError) setCaptchaError("");
                                }}
                                autoComplete="off"
                              />

                              {captchaError && (
                                <div className="font-sm regular text-danger position-absolute">{captchaError}</div>
                              )}
                            </div>


                          </div>


                          <Button type="submit" className="btn-primary submit-btn font-xl btn btn-animation w-100">
                            LOGIN
                          </Button>
                          <div className="d-flex mt-2 justify-content-between align-items-center mt-0">
                            <div class="forgot-password-text">
                              <Link type="button" className="d-lg-none d-inline-block font-sm primary-text text-decoration-none" onClick={() => setIsSignin(true)}>
                          Register New Employee
                        </Link>
                            </div>
                            <div className="forgot-password-text">
                              <Link className="font-sm primary-text text-decoration-none" to={`/forgot-password`}>Forgot your Password?</Link>
                            </div>

                          </div>
                        </Form>
                      </div>
                    </div>

                    <div className="form-panel signin-form">
                      <div className="logo mt-0">
                        <img src="./images/logo.svg" alt="spicejet" className="img-fluid" />
                      </div>
                      <RegisterEmp setIsSignin={setIsSignin} />
                    </div>

                  </div>

                </div>

              </Col>
            </Row>

          </div>
        </Container>
      </section>
    </>
  );
};

export default Login2;